import React, { useState, useEffect } from "react";
import { Cookie, X } from "lucide-react";

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // No mostrar el banner en zona autenticada (admin) — interfiere con el flujo del comercial
    const checkAuth = () => {
      const isAuthenticated = !!localStorage.getItem("mobilsafe_token");
      if (isAuthenticated) {
        setShowBanner(false);
        return true;
      }
      return false;
    };

    if (checkAuth()) return;

    // Verificar si ya aceptó las cookies
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    if (!cookiesAccepted) {
      // Mostrar después de un pequeño delay para mejor UX
      setTimeout(() => setShowBanner(true), 1000);
    }

    // Re-evaluar tras login en la misma sesión SPA
    const onStorage = () => checkAuth();
    window.addEventListener("storage", onStorage);
    window.addEventListener("auth-changed", onStorage);
    return () => {
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("auth-changed", onStorage);
    };
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    localStorage.setItem('cookiesAcceptedDate', new Date().toISOString());
    setShowBanner(false);
  };

  const rejectCookies = () => {
    localStorage.setItem('cookiesAccepted', 'essential');
    localStorage.setItem('cookiesAcceptedDate', new Date().toISOString());
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-in slide-in-from-bottom duration-300">
      <div className="max-w-4xl mx-auto bg-slate-900/95 backdrop-blur-lg border border-emerald-500/30 rounded-2xl p-6 shadow-2xl">
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 bg-emerald-500/20 rounded-xl flex items-center justify-center flex-shrink-0">
            <Cookie className="w-6 h-6 text-emerald-400" />
          </div>
          
          <div className="flex-1">
            <h3 className="text-white font-bold text-lg mb-2">
              Utilizamos cookies
            </h3>
            <p className="text-slate-300 text-sm mb-4">
              Usamos cookies propias y de terceros para mejorar tu experiencia, analizar el tráfico y personalizar contenido. 
              Puedes aceptar todas las cookies o configurar tus preferencias.
            </p>
            
            <div className="flex flex-wrap gap-3">
              <button
                onClick={acceptCookies}
                className="px-6 py-2 bg-gradient-to-r from-emerald-500 to-green-500 hover:from-emerald-600 hover:to-green-600 rounded-lg font-semibold text-sm transition-all"
                data-testid="accept-cookies-btn"
              >
                Aceptar todas
              </button>
              <button
                onClick={rejectCookies}
                className="px-6 py-2 bg-slate-700 hover:bg-slate-600 rounded-lg font-semibold text-sm transition-all"
                data-testid="reject-cookies-btn"
              >
                Solo esenciales
              </button>
              <a
                href="https://www.mobilsafe.es/politica-de-cookies/"
                target="_blank"
                rel="noopener noreferrer"
                className="px-6 py-2 text-emerald-400 hover:text-emerald-300 font-semibold text-sm transition-all flex items-center"
              >
                Más información
              </a>
            </div>
          </div>

          <button 
            onClick={rejectCookies}
            className="p-2 hover:bg-slate-700 rounded-lg transition-all text-slate-400 hover:text-white"
            aria-label="Cerrar"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
